module.exports = __webpack_public_path__ + "c28010ec54b52cb7b2dd136f4bc4b8a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/vipcz/miko.jpg
// module id = 601
// module chunks = 30